/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ListEducationLevelsWithTrackCategoryEducationLevelDtoFromJSON, ListEducationLevelsWithTrackCategoryEducationLevelDtoToJSON, } from './ListEducationLevelsWithTrackCategoryEducationLevelDto.js';
/**
 * Check if a given object implements the ListEducationLevelsWithTrackCategoryResult interface.
 */
export function instanceOfListEducationLevelsWithTrackCategoryResult(value) {
    if (!('educationLevels' in value) || value['educationLevels'] === undefined)
        return false;
    return true;
}
export function ListEducationLevelsWithTrackCategoryResultFromJSON(json) {
    return ListEducationLevelsWithTrackCategoryResultFromJSONTyped(json, false);
}
export function ListEducationLevelsWithTrackCategoryResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'educationLevels': (json['educationLevels'].map(ListEducationLevelsWithTrackCategoryEducationLevelDtoFromJSON)),
    };
}
export function ListEducationLevelsWithTrackCategoryResultToJSON(json) {
    return ListEducationLevelsWithTrackCategoryResultToJSONTyped(json, false);
}
export function ListEducationLevelsWithTrackCategoryResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'educationLevels': (value['educationLevels'].map(ListEducationLevelsWithTrackCategoryEducationLevelDtoToJSON)),
    };
}
